import { render, staticRenderFns } from "./CampaignAssignHistory.vue?vue&type=template&id=4904e640&"
import script from "./CampaignAssignHistory.vue?vue&type=script&lang=js&"
export * from "./CampaignAssignHistory.vue?vue&type=script&lang=js&"
import style0 from "./CampaignAssignHistory.vue?vue&type=style&index=0&id=4904e640&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports